import { useId, useState } from 'react'
import { ConfirmDialog } from '@/components/patterns/ConfirmDialog'
import type { OwnerTransfer } from './types'

function counts(transfer: OwnerTransfer): string {
  const agreements = transfer.agreements === 1 ? '1 afspraak' : `${transfer.agreements} afspraken`
  const tasks = transfer.tasks === 1 ? '1 open taak' : `${transfer.tasks} open taken`
  if (transfer.agreements > 0 && transfer.tasks > 0) return `${agreements} en ${tasks}`
  return transfer.agreements > 0 ? agreements : tasks
}

/**
 * The question when the owner of a relation changes (ED-33): hand over its agreements and open
 * tasks too? Checked by default. `transfer` is what would be handed over (`getOwnerTransfer`); the
 * caller only opens this dialog when there is something. `onConfirm(true)` transfers.
 */
export function OwnerTransferDialog({
  open,
  onOpenChange,
  transfer,
  newOwnerName,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  transfer: OwnerTransfer
  newOwnerName: string
  onConfirm: (transfer: boolean) => void
}) {
  const id = useId()
  const [checked, setChecked] = useState(true)
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Eigenaar wijzigen"
      description={`${newOwnerName} wordt de nieuwe eigenaar van deze relatie.`}
      confirmLabel="Eigenaar wijzigen"
      destructive={false}
      onConfirm={() => onConfirm(checked)}
    >
      <label htmlFor={id} className="mt-3 flex items-start gap-2 text-sm">
        <input id={id} type="checkbox" className="mt-1" checked={checked} onChange={(event) => setChecked(event.target.checked)} />
        Ook {counts(transfer)} overdragen aan {newOwnerName}
      </label>
    </ConfirmDialog>
  )
}
